import styled from "styled-components";

export const StartButton = styled.button`
  background: #eb7c00;
  border: none;
  border-radius: 25px;
  padding: 0.5rem;
`;

export const TabButton = styled.button`
  background: ${props => props.color || 'rgb(16, 30, 142)'};
  font-family: 'Segoe UI';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  display:flex;
  align-items:center;
  justify-content:center;
  width: 231px;
  height: 50px;
  color: white;
  border: none;
  @media (max-width: 991px) {
    margin-bottom : 10px;
  }
`;

export const DELINK = styled.button`
  border: 1px solid #101e8e;
  background: transparent;
  color: #101e8e;
  padding: 0.6rem;
  transition: ease-in-out 0.3s;
  cursor: pointer;

`;
